import { apiSlice } from "../apiSlice/apiSlice";

export const quizApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuizzes: builder.query({
            query: () => `/quizzes`
        }),
        getQuizzesWithVideoId: builder.query({
            query: (videoId) => `/quizzes?video_id=${videoId}`
        }),
        addQuiz: builder.mutation({
            query: (data) => ({
                url: '/quizzes',
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {};

                // update data 
                dispatch(apiSlice.util.updateQueryData(
                    "getQuizzes",
                    undefined,
                    (draft) => {
                        draft.push(data);
                    }
                ));

            }
        }),
        editQuiz: builder.mutation({
            query: (info) => {

                return {
                    url: `/quizzes/${info.id}`,
                    method: "PATCH",
                    body: info
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {};

                // update data 
                dispatch(apiSlice.util.updateQueryData(
                    "getQuizzes",
                    undefined,
                    (draft) => {
                        const index = draft.findIndex(single => single.id === data.id)
                        draft[index] = {
                            ...draft[index],
                            ...data
                        }
                    }
                ));

                dispatch(apiSlice.util.updateQueryData(
                    'getQuizzesWithVideoId',
                    data.video_id,
                    (draft) => {
                        draft[0] = data
                    }
                ))

            }
        }),
        deleteQuiz: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `/quizzes/${id}`,
                    method: "DELETE",
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // const result = await queryFulfilled;

                // update data 
                const pathResult1 = dispatch(
                    apiSlice.util.updateQueryData(
                        "getQuizzes",
                        undefined,
                        (draft) => {
                            const index = draft?.findIndex(single => single.id === arg.id)


                            if (index !== -1) draft.splice(index, 1)
                        }
                    )
                );
                const pathResult2 = dispatch(
                    apiSlice.util.updateQueryData(
                        "getQuizzesWithVideoId",
                        arg.video_id,
                        (draft) => {
                            const index = draft?.findIndex(single => single.video_id === arg.video_id)


                            if (index !== -1) draft.splice(index, 1)
                        }
                    )
                );
                // optimistic cache update end
                try {
                    const result = await queryFulfilled;
                } catch (err) {
                    pathResult1.undo()
                    pathResult2.undo()
                }

            }



        })
    })
});
export const { useGetQuizzesQuery, useGetQuizzesWithVideoIdQuery, useAddQuizMutation, useEditQuizMutation, useDeleteQuizMutation } = quizApi;